import React, { PureComponent } from 'react';
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, Cell, Line
} from 'recharts';

class SimpleBarChart extends PureComponent {
	render () {
  	return (
      <ResponsiveContainer height={500} width='100%'>
        <ComposedChart
           width='100%'
           height={300}
            layout="vertical"
          data={this.props.data}>
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis type="number" />
          <YAxis dataKey="Ejecutivo" type="category" tick={{fontSize: 8}} interval={0}/>
          <Tooltip/>
          <Legend />
          <Bar dataKey="BANCOLOMBIA"  stroke="#ECDD00" fill="#ECDD00" stackId="a" />
          <Bar dataKey="BBVA"  stroke="#0901C7" fill="#0901C7" stackId="a" />
          <Bar dataKey="DAVIVIENDA"  stroke="#DB1500" fill="#DB1500" stackId="a" />
          <Bar dataKey="OTROS BANCOS"  stroke="#79786F" fill="#79786F" stackId="a" />
          <Line type="monotone" dataKey="BancoTotal.Total" stroke="#000000" name="Total" />

        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}

export default SimpleBarChart;